import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipPricingDiscountsView } from './discounts/discounts';

export const MembershipPricingView = angular
  .module('acme.view.application.membership.pricing', [
    uiRouter,
    'ui.bootstrap',
    MembershipPricingDiscountsView,
    'acme.view.application.membership.pricing.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.membership.pricing',
      url: '/pricing',
      views: {
        'subview-main': {
          controller: 'MembershipPricingController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/pricing/pricing.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Pricing',
      },
    });
  }).name;
